module.exports = __webpack_public_path__ + "static/obj1@2x-5c988ebb45d6c14450e6435a51167eb8.png";